import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

const IconLineApp = ({ className, height, width, fill }: IconInterface) => (
  <svg className={className} width={width} height={height} viewBox='0 0 35 35'>
    <g transform='translate(-2 -2)' fill='none' fillRule='evenodd'>
      <rect width={39} height={39} rx={5} />
      <path
        d='M5.5 10.867c-.644 0-1.167.524-1.167 1.166V33.5c0 .643.523 1.167 1.167 1.167h21.467c.644 0 1.166-.524 1.166-1.167V12.033c0-.642-.522-1.166-1.166-1.166H5.5zM26.967 37H5.5C3.57 37 2 35.43 2 33.5V12.033c0-1.93 1.57-3.5 3.5-3.5h21.467c1.93 0 3.5 1.57 3.5 3.5V33.5c0 1.93-1.57 3.5-3.5 3.5zm6.673-6.725a1.166 1.166 0 1 1 0-2.334c.566 0 1.027-.46 1.027-1.026V5.5c0-.644-.523-1.166-1.167-1.166H12.226c-.644 0-1.167.522-1.167 1.166 0 .644-.522 1.223-1.166 1.223-.646 0-1.167-.465-1.167-1.11 0-2.043 1.57-3.613 3.5-3.613H33.5C35.43 2 37 3.57 37 5.5v21.415a3.364 3.364 0 0 1-3.36 3.36z'
        fill={fill}
      />
    </g>
  </svg>
)

export default Icon(IconLineApp)
